import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Progress } from "./ui/progress";
import React from "react";
import { t } from "i18next";

interface UploadStatusDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  uploadProgress: number;
}

const UploadStatusDialog: React.FC<UploadStatusDialogProps> = ({
  open,
  setOpen,
  uploadProgress,
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="!max-w-180"
        aria-describedby="Dialog para status de upload"
      >
        <DialogHeader>
          <DialogTitle>{t("uploadStatusDialog.title")}</DialogTitle>
          <DialogDescription>
            {t("uploadStatusDialog.description")}
          </DialogDescription>
        </DialogHeader>

        <h3>
          <span className="font-medium">{t("uploadStatusDialog.subtitle")}</span> {uploadProgress}%
        </h3>
        <Progress
          value={uploadProgress}
          className="bg-neutro-200"
        />
      </DialogContent>
    </Dialog>
  );
};

export default UploadStatusDialog;
